import { useState } from "react";
import { Box, Button, Paper, TextField, Typography } from "@mui/material";
import { toast } from "react-toastify";

/**
 * Not really a "tool" - a standing invitation in the nav to suggest the next
 * one. Doesn't persist anywhere; it just gives engineers a place to drop an
 * idea instead of that idea living nowhere.
 */
export function SuggestAToolPage() {
  const [idea, setIdea] = useState("");

  const handleSubmit = () => {
    toast.success("That button did nothing ! Just message your idea to Levi 🙌 ", {
      position: "bottom-right",
      autoClose: 6000,
    });
    setIdea("");
  };

  return (
    <>
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
        What should we add next?
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Publish Event and Email Queue are done, and this toolset keeps growing. Got an idea for a
        dev tool that'd save you time - Drop it below.
      </Typography>

      <Paper
        elevation={0}
        sx={{
          p: 3,
          backgroundColor: "background.paper",
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        <TextField
          fullWidth
          multiline
          minRows={4}
          label="Tool idea"
          placeholder="gimme some ideas"
          variant="outlined"
          value={idea}
          onChange={(e) => setIdea(e.target.value)}
          sx={{ mb: 2 }}
        />
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            variant="contained"
            disableElevation
            disabled={!idea.trim()}
            onClick={handleSubmit}
          >
            Suggest it
          </Button>
        </Box>
      </Paper>
    </>
  );
}
